import {
  feSetClientProfileBookingsActiveTab,
  feSetClientProfileBookingsCounts,
  feSetClientProfileData,
  feSetClientProfileEditData,
  feSetClientProfileMessagesState,
  feSetClientProfileOverviewNameHidden,
  feSetClientProfileSelectedBooking,
} from 'actions/client/clientProfile.action';
import { feSidebarClose, feSidebarOpen } from 'actions/ui.actions';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import logger from 'utils/logger.util';
import { isValidId } from 'utils/predicates/fields.util';

const L = logger('clientProfileSidebarReducer');

const reduceOpen = (state, action) => {
  const clientId = action?.data?.clientId;
  const originPanel = action?.data?.originPanel ?? null;

  if (!isValidId(clientId)) {
    L.warn('()', action?.ATAG, 'Invalid clientId:', clientId);
    return { ...state, originPanel: null };
  }

  return {
    ...state,
    clientId,
    open: true,
    bookingsCounts: null,
    clientData: null,
    editData: null,
    messages: null,
    originPanel,
  };
};

const reduceClose = (state) => ({
  ...state,
  clientId: null,
  open: false,
  bookingsCounts: null,
  clientData: null,
  editData: null,
  selectedBooking: null,
  bookingsActiveTab: null,
  messages: null,
  overviewNameHidden: false,
  originPanel: null,
});

const reduceSetBookingsCounts = (state, action) => {
  const { pastCount, futureCount } = action?.data ?? {};
  const current = state?.bookingsCounts ?? {};

  return {
    ...state,
    bookingsCounts: {
      past: fromAnyToNumber(pastCount) || current.past,
      future: fromAnyToNumber(futureCount) || current.future,
    },
  };
};

const reduceSetClientProfileData = (state, action) => {
  const clientData = action?.data ?? null;

  return {
    ...state,
    clientData,
  };
};

const reduceSetClientProfileEditData = (state, action) => {
  const editData = action?.data ?? null;

  return {
    ...state,
    editData,
  };
};

const reduceSetClientProfileSelectedBooking = (state, action) => {
  const selectedBooking = action?.data ?? null;

  return {
    ...state,
    selectedBooking,
  };
};

const reduceSetClientProfileBookingsActiveTab = (state, action) => ({
  ...state,
  bookingsActiveTab: action?.data ?? null,
});

const reduceSetClientProfileMessagesState = (state, action) => ({
  ...state,
  messages: {
    ...(state?.messages ?? {}),
    ...(action?.data ?? {}),
  },
});

const reduceSetClientProfileOverviewNameHidden = (state, action) => ({
  ...state,
  overviewNameHidden: action?.data ?? false,
});

const MAP = Object.freeze({
  [feSidebarOpen.AT.name]: reduceOpen,
  [feSidebarClose.AT.name]: reduceClose,
  [feSetClientProfileBookingsCounts.AT.name]: reduceSetBookingsCounts,
  [feSetClientProfileData.AT.name]: reduceSetClientProfileData,
  [feSetClientProfileEditData.AT.name]: reduceSetClientProfileEditData,
  [feSetClientProfileSelectedBooking.AT.name]: reduceSetClientProfileSelectedBooking,
  [feSetClientProfileBookingsActiveTab.AT.name]: reduceSetClientProfileBookingsActiveTab,
  [feSetClientProfileMessagesState.AT.name]: reduceSetClientProfileMessagesState,
  [feSetClientProfileOverviewNameHidden.AT.name]: reduceSetClientProfileOverviewNameHidden,
});

const clientProfileSidebarReducer = (state, action) => (MAP[action?.type] ?? alwaysSame)(state ?? {}, action ?? {});

// noinspection JSUnusedGlobalSymbols
export default clientProfileSidebarReducer;
